<template>
  <v-container fluid tag="section">
    <base-material-card
      color="primary"
      inline
      icon="mdi-chart-areaspline"
      class="px-5 py-3"
      title="Serviços por Área e Gerência"
      elevation="0"
    >
      <v-tabs v-model="tab" grow color="primary" class="mt-5">
        <v-tab>
          Áreas
        </v-tab>
        <v-tab>
          Gerências
        </v-tab>
      </v-tabs>

      <section id="section-filtros">
        <v-row class="mt-4" justify="space-between">
          <v-col cols="12" md="auto">
            <div
              class="text-subtitle-1 font-weight-medium mb-2 grey--text body-2"
            >
              Competência
            </div>
            <div class="d-flex align-center">
              <input-month
                rules="min:7"
                :minMonth="'2023-01'"
                :selectedMonth="competenciaDe"
                @monthSelected="setCompetenciaDe"
                outlined
                dense
                class="mr-4"
              />
              <span class="mx-3 grey--text body-2">
                até
              </span>
              <input-month
                rules="min:7"
                :minMonth="'2023-01'"
                :selectedMonth="competenciaAte"
                @monthSelected="setCompetenciaAte"
                outlined
                dense
              />
            </div>
          </v-col>

          <v-col v-if="tab === 0" cols="6" sm="3">
            <v-autocomplete
              :items="listAreas"
              v-model="selectingAreas"
              @blur="commitSelectingAreas"
              multiple
              small-chips
              deletable-chips
              label="Área"
              class="mt-0 pt-1"
              hide-details
            />
          </v-col>

          <v-col v-if="tab === 1" cols="6" sm="3">
            <v-autocomplete
              :items="listGerencias"
              v-model="selectingGerencias"
              @blur="commitSelectingGerencias"
              multiple
              small-chips
              deletable-chips
              label="Gerências"
              class="mt-0 pt-1"
              hide-details
            />
          </v-col>
        </v-row>
      </section>
    </base-material-card>

    <v-tabs-items
      v-model="tab"
      style="background-color: transparent !important;"
    >
      <v-tab-item>
        <v-row class="mt-6">
          <v-col cols="12">
            <data-table-sup-ger
              :headers="headers"
              :items="itemsGroupedByArea"
              style="box-shadow: none !important;"
            />
          </v-col>
        </v-row>

        <v-row class="mt-6">
          <v-col cols="auto" class="titulo">
            Indicadores agrupados por Área
          </v-col>
        </v-row>

        <v-row justify="center" dense>
          <v-col
            cols="6"
            v-for="indicador in indicadores"
            :key="indicador.value"
          >
            <indicador-by-sup-ger-chart
              :indicador="indicador"
              isSup
              :listSupGer="selectedArea"
              :dados="dadosByArea"
              style="box-shadow: none !important;"
            />
          </v-col>
        </v-row>

        <v-row class="mt-6">
          <v-col cols="auto" class="titulo">
            Indicadores agrupados por competência (mês/ano)
          </v-col>
        </v-row>

        <v-row justify="center" dense>
          <v-col
            cols="6"
            v-for="indicador in indicadores"
            :key="indicador.value + '-comp'"
          >
            <indicador-sup-ger-by-competencia-chart
              :indicador="indicador"
              :competenciaDe="competenciaDe"
              :competenciaAte="competenciaAte"
              :dados="dadosAreaByCompetencia"
              style="box-shadow: none !important;"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row class="mt-6">
          <v-col cols="12">
            <data-table-sup-ger
              :headers="headers"
              :items="itemsGroupedByGerencia"
              style="box-shadow: none !important;"
            />
          </v-col>
        </v-row>

        <v-row class="mt-6">
          <v-col cols="auto" class="titulo">
            Indicadores agrupados por Gerência
          </v-col>
        </v-row>

        <v-row justify="center" dense>
          <v-col
            cols="6"
            v-for="indicador in indicadores"
            :key="'g-' + indicador.value"
          >
            <indicador-by-sup-ger-chart
              :indicador="indicador"
              :listSupGer="selectedGerencias"
              :dados="dadosByGerencias"
              style="box-shadow: none !important;"
            />
          </v-col>
        </v-row>

        <v-row class="mt-6">
          <v-col cols="auto" class="titulo">
            Indicadores agrupados por competência (mês/ano)
          </v-col>
        </v-row>

        <v-row justify="center" dense>
          <v-col
            cols="6"
            v-for="indicador in indicadores"
            :key="'gc-' + indicador.value"
          >
            <indicador-sup-ger-by-competencia-chart
              :indicador="indicador"
              :competenciaDe="competenciaDe"
              :competenciaAte="competenciaAte"
              :dados="dadosGerenciasByCompetencia"
              style="box-shadow: none !important;"
            />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
  </v-container>
</template>

<script>
  import ServicosAreaService from "@/services/ServicosAreaService";
  import AreasService from "@/services/AreasService";
  import GerenciasService from "@/services/GerenciasService";
  import { mapState, mapActions } from "vuex";

  export default {
    name: "DashboardServicosArea",
    components: {
      InputMonth: () => import("@/components/general/InputMonth.vue"),
      IndicadorBySupGerChart: () =>
        import("@/components/servicosArea/IndicadorBySupGerChart.vue"),
      IndicadorSupGerByCompetenciaChart: () =>
        import(
          "@/components/servicosArea/IndicadorSupGerByCompetenciaChart.vue"
        ),
      DataTableSupGer: () =>
        import("@/components/servicosArea/DataTableSupGer.vue"),
    },
    data() {
      return {
        tab: 0,
        indicadores: [
          { value: "qtd_servicos", text: "Qtd. Serviços" },
          { value: "qtd_violada", text: "Qtd. Violada" },
          { value: "valor_creditado", text: "Valor Creditado" },
        ],
        loading: true,
        listAreas: [],
        listGerencias: [],
        parametrosCarregados: false,
        selectingGerencias: [],
        selectingAreas: [],
        dadosByArea: {},
        dadosAreaByCompetencia: {},
        dadosByGerencias: {},
        dadosGerenciasByCompetencia: {},
      };
    },
    computed: {
      ...mapState("parametrosDashboardServicosArea", [
        "competenciaDe",
        "competenciaAte",
        "selectedArea",
        "selectedGerencias",
      ]),
      headers() {
        const isArea = this.tab === 0;

        return [
          {
            text: isArea ? "Área" : "Gerência",
            value: isArea ? "area" : "gerencia",
          },
          { text: "Qtd. Serviços", value: "qtd_servicos" },
          { text: "Qtd. Violada", value: "qtd_violada" },
          { text: "Valor Creditado", value: "valor_creditado" },
          { text: "PSP", value: "psp" },
        ];
      },
      itemsGroupedByArea() {
        const rows = this.selectedArea.map(
          (name) => this.dadosByArea[name] ?? {},
        );
        return this.sumServicosTableItems(rows, "area");
      },
      itemsGroupedByGerencia() {
        const rows = this.selectedGerencias.map(
          (name) => this.dadosByGerencias[name] ?? {},
        );
        return this.sumServicosTableItems(rows, "gerencia");
      },
    },
    async created() {
      this.setRangeCompetencias();
      await this.getParametros();
      this.getDados();
    },
    methods: {
      ...mapActions("parametrosDashboardServicosArea", [
        "setRangeCompetencias",
        "setCompetenciaDe",
        "setCompetenciaAte",
        "setSelectedArea",
        "setSelectedGerencias",
      ]),
      sumServicosTableItems(items, labelKey) {
        if (!items.length) {
          return items;
        }
        const toNum = (v) => {
          const n = Number(v);
          return Number.isFinite(n) ? n : 0;
        };
        let qtd_servicos = 0;
        let qtd_violada = 0;
        let valor_creditado = 0;
        for (const row of items) {
          qtd_servicos += toNum(row.qtd_servicos);
          qtd_violada += toNum(row.qtd_violada);
          valor_creditado += toNum(row.valor_creditado);
        }
        return [
          ...items,
          {
            [labelKey]: "Total",
            qtd_servicos,
            qtd_violada,
            valor_creditado,
            psp: null,
          },
        ];
      },
      commitSelectingAreas() {
        this.setSelectedArea([...this.selectingAreas]);
      },
      commitSelectingGerencias() {
        this.setSelectedGerencias([...this.selectingGerencias]);
      },
      async getParametros() {
        if (!this.$store.getters.getCompanyId) {
          this.$toast.info(
            "Selecione uma empresa para carregar áreas e gerências neste painel.",
            "",
            { position: "topRight" },
          );
        }

        return Promise.all([this.getAreas(), this.getGerencias()])
          .then(() => {
            this.parametrosCarregados = true;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar parâmetros de filtragem", "", {
              position: "topRight",
            });
          })
          .finally(() => (this.loading = false));
      },
      getDados() {
        if (!this.parametrosCarregados) return;

        this.loading = true;

        if (this.tab === 0) {
          this.getDadosAreaTab();
          return;
        }
        if (this.tab === 1) {
          this.getDadosGerenciasTab();
          return;
        }
      },
      getDadosAreaTab() {
        Promise.all([
          this.fetchDadosByArea(),
          this.fetchDadosAreaByCompetencia(),
        ])
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar dados", "", {
              position: "topRight",
            });
          })
          .finally(() => (this.loading = false));
      },
      getDadosGerenciasTab() {
        Promise.all([
          this.fetchDadosByGerencia(),
          this.fetchDadosGerenciaByCompetencia(),
        ])
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar dados", "", {
              position: "topRight",
            });
          })
          .finally(() => (this.loading = false));
      },
      async getAreas() {
        return AreasService.getAll()
          .then((response) => {
            this.listAreas = response.map((s) => s.nome);
            const saved = this.selectedArea.filter((n) =>
              this.listAreas.includes(n),
            );
            const next = saved.length ? saved : [...this.listAreas];
            this.setSelectedArea(next);
            this.selectingAreas = [...next];
          })
          .catch((error) => {
            throw new Error(error);
          });
      },
      async getGerencias() {
        return GerenciasService.getAll()
          .then((response) => {
            this.listGerencias = response.map((s) => s.nome);
            const saved = this.selectedGerencias.filter((n) =>
              this.listGerencias.includes(n),
            );
            const next = saved.length ? saved : [...this.listGerencias];
            this.setSelectedGerencias(next);
            this.selectingGerencias = [...next];
          })
          .catch((error) => {
            throw new Error(error);
          });
      },
      async fetchDadosByArea() {
        const response = await ServicosAreaService.getDadosByArea(
          this.competenciaDe,
          this.competenciaAte,
          this.selectedArea,
        );
        this.dadosByArea = response;
      },
      async fetchDadosAreaByCompetencia() {
        const response = await ServicosAreaService.getDadosAreaByCompetencia(
          this.competenciaDe,
          this.competenciaAte,
          this.selectedArea,
        );
        this.dadosAreaByCompetencia = response;
      },
      async fetchDadosByGerencia() {
        const response = await ServicosAreaService.getDadosByGerencia(
          this.competenciaDe,
          this.competenciaAte,
          this.selectedGerencias,
        );
        this.dadosByGerencias = response;
      },
      async fetchDadosGerenciaByCompetencia() {
        const response = await ServicosAreaService.getDadosGerenciaByCompetencia(
          this.competenciaDe,
          this.competenciaAte,
          this.selectedGerencias,
        );
        this.dadosGerenciasByCompetencia = response;
      },
    },
    watch: {
      competenciaDe() {
        this.getDados();
      },
      competenciaAte() {
        this.getDados();
      },
      selectedArea(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.getDados();
        }
      },
      selectedGerencias(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.getDados();
        }
      },
      tab() {
        this.getDados();
      },
    },
  };
</script>

<style>
  .titulo {
    font-family: "styrene A" !important;
    font-weight: 500 !important;
    color: #3c4858 !important;
    font-size: 18px !important;
  }
</style>
